// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3OpOP","projectsConteiner":"styles_projectsConteiner__25p6f","main":"styles_main__QyAqC"};